import { SetupHouseholdModal } from "components/accounts/SetupHouseholdModal"
import React from "react"
import { Button } from "semantic-ui-react"

export default class CreateHouseholdButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = { loading: false, success: false, isModalOpen: false }
  }
  handleOpen = () => {
    this.setState({ isModalOpen: true })
  }
  handleClose = () => this.setState({ isModalOpen: false })

  onCreateHousehold = async values => {
    await this.props.createHousehold(values)
    window.trackEvent("setup-household")
    this.setState({ loading: false, success: true, isModalOpen: false })
  }
  render = () => (
    <span>
      <Button
        content="Create Household"
        basic
        color="blue"
        type="button"
        disabled={this.state.loading}
        loading={this.state.loading}
        onClick={() => this.handleOpen()}
      />
      {this.state.isModalOpen ? (
        <SetupHouseholdModal
          values={{
            first_name: this.props.currentUser.first_name
          }}
          submit={this.onCreateHousehold}
          onCancel={this.handleOnCancel}
        />
      ) : null}
    </span>
  )
}
